

import { SET_TOKEN, SET_ME } from '../actions/authActions';

const initialState: AuthReducerState = {
    token: localStorage.getItem('token') ? localStorage.getItem('token') as string : '',
    me: null
}

const authReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_TOKEN:
            return {
                ...state,
                token: action.value
            }
        case SET_ME:
            return {
                ...state,
                me: action.value
            }
        default:
            return state;
    }
}

export interface AuthReducerState {
    token: string;
    me: any;
}


export default authReducer;